<template>
  <div>
    <Head title="Termos de Uso" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Termos de Uso</h1>
      <data-table
        v-if="loadTable"
        :disableSearch="true"
        :disablePagination="true"
        v-model:columns="columns"
        route="terms/list"
        no-data-label="Nenhum termo de uso cadastrado"
        no-result-label="Nenhum termo de uso encontrado"
      >
        <template #table.cell.content.terms_status="{ value, row }">
            <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.terms_status="{ value, row }">
            <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>

        <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-1 ">
                <span v-if="user.role == 2" @click="openModalDetail(row)"><font-awesome-icon icon="fa-eye" class="text-green-600 text-lg cursor-pointer" /></span>
                <span v-if="user.role == 1" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-1 ">
                <span v-if="user.role == 2" @click="openModalDetail(row)"><font-awesome-icon icon="fa-eye" class="text-green-600 text-lg cursor-pointer" /></span>
                <span v-if="user.role == 1" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            </div>
        </template>
      </data-table>
    </div>
    <modal-edit ref="modalEdit" title="Termo" url="terms" @submitForm="reloadTable">
      <template #form="{item}">
        <textarea-input v-model="item.value" :error="item.errors.value" class="w-full" label="Descrição" />
      </template>
    </modal-edit>
    <modal ref="modalDetail" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true">
      <template #header>
          <div class="text-gray-777 font-roboto uppercase">
              <span>{{ selectedDetailItem.key_label }}</span>
          </div>
      </template>
      <template #body>
        {{ selectedDetailItem.value }}
      </template>
      <template #footer>
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModalDetail">Fechar</button>
      </template>
    </modal>
<modal-update-photo-profile ref="modalUpdatePhotoProfile" />

  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import TextareaInput from '@/Shared/Fields/TextareaInput'
import DataTable from '@/Shared/Components/DataTable'
import SelectInput from '@/Shared/Fields/SelectInput'
import Modal from '@/Shared/Modal/Modal'
import ModalUpdatePhotoProfile from '@/Shared/Modal/ModalUpdatePhotoProfile'

export default {
  
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  props: {
    types_options: Object,
  },
  components: {
    computed,
    usePage,
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    SwitchInput,
    TextInput,
    TextareaInput,
    DataTable,
    SelectInput,
    Modal,
    ModalUpdatePhotoProfile,
  },
  layout: Layout,
  mounted() {
    if(this.user.professional){
      if(!this.user.photo) {
        this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
      }
    }
    
  },
  data() {
    return {
      selectedDetailItem: {},
      loadTable: true,
      columns: [
        {
          uniqid: 'terms_key',
          label: 'Termo',
          field: 'key',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.key_label
        },
        {
          uniqid: 'terms_value',
          label: 'Descrição',
          field: 'value',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        key: item.key,
        value: item.value,
      });
    },
    openModalDetail(item) {
      this.selectedDetailItem = item;
      this.$refs.modalDetail.showModal = true;
    },
    closeModalDetail() {
      this.$refs.modalDetail.showModal = false;
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    openModalUpdatePhotoProfile() {
      this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
    },
  },
}
</script>